//lib/authUtils.ts
export function isUnauthorizedError(error: Error): boolean {
  // Matches typical 401 error messages from fetch/axios or custom backend
  return (
    error.message.includes("401") ||
    error.message.toLowerCase().includes("unauthorized")
  );
}